import React, { useEffect, useRef, useState } from "react";
import NavBar from "../../Components/Navbar/navbar";
import { useLocation, useNavigate } from "react-router";
import styles from "../Styles/tables.module.css";
import { Url, getUser } from "../../Constants/globals";
import { TbArrowBigLeftFilled, TbArrowBigRightFilled, TbArrowBigRightLinesFilled, TbArrowBigLeftLinesFilled } from "react-icons/tb";
import axios from "axios";
import RefreshToken from "../../Components/RefreshToken/RefreshToken";
import { HiPencil, HiPlus, HiTrash, HiSearch, HiX, HiDownload } from "react-icons/hi";
import { HiSquares2X2 } from "react-icons/hi2";
import DeleteModal from "../../Components/DeleteModal/deletemodal";
import Alert from "../../Components/Alert/alert";
import Loading from "../../Components/Loading/loading";

async function deleteProtocolFunction(id){
  try {
    await axios.delete(`${Url}/protocols/${id}`, {
      headers: {
        Authorization: "Bearer " + getUser().token,
      },
    });
    return [200, <Alert type={"success"}>Protocolo eliminado com sucesso!</Alert>];
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await deleteProtocolFunction(id);
      }
      else {
        window.location.reload();
      }
    }
    else {
      console.error(err);
      return  [0, <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao eliminar o protocolo"}</Alert>];
    }
  };
}

async function getProtocols(page, search){
  try {
    const res = await axios
    .get(`${Url}/protocols?page=${page ? page : 1}${search ? "&search="+search : ""}`, {
      headers: {
        Authorization: "Bearer "+getUser().token,
      },
    });
    return res.data;
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await getProtocols(page, search);
      }
      else {
        window.location.reload();
      }
    }
    else {
      console.error(err);
      return [];
    }
  };
}

function Protocolos({userPermissions}) {

  const location = useLocation();
  const { state } = location;
  const navigate = useNavigate();
  const searchRef = useRef(null);
  const [loadingData, setLoadingData] = useState(true);
  const [loading, setLoading] = useState("");

  const [deleteProtocol, setDeleteProtocol] = useState("");
  const [alert, setAlert] = useState("");

  const [protocolsData, setProtocolsData] = useState([]);
  const [previousPage, setPreviousPage] = useState("");
  const [nextPage, setNextPage] = useState("");
  const [currentPage, setCurrentPage] = useState(state?.page ? state.page : "");
  const [total, setTotal] = useState(0);
  const [perPage, setPerPage] = useState(10);

  const [showSearch, setShowSearch] = useState(false);
  const [isPoppedOutSearch, setIsPoppedOutSearch] = useState(false);
  const [nomeSearch, setNomeSearch] = useState("");


  async function assignData() {
    const thisProtocolsData = await getProtocols(currentPage);
    setCurrentPage(thisProtocolsData.current_page);
    setNextPage(thisProtocolsData.next_page);
    setTotal(thisProtocolsData.total_protocols);
    setPreviousPage(thisProtocolsData.prev_page);
    setPerPage(thisProtocolsData.per_page);
    setProtocolsData(thisProtocolsData);
    setLoadingData(false);
  }

  useEffect(() => {
    assignData();
  }, []);

  async function handlePageChange(next, start) {
    if (next) {
      const newProtocolsData = await getProtocols(start ? start : nextPage, nomeSearch);
      setProtocolsData(newProtocolsData);
      setCurrentPage(newProtocolsData.current_page);
      setNextPage(newProtocolsData.next_page);
      setPreviousPage(newProtocolsData.prev_page);
      setPerPage(newProtocolsData.per_page);
      setTotal(newProtocolsData.total_protocols);
    }
    else if (!next && previousPage) {
      const newProtocolsData = await getProtocols(previousPage, nomeSearch);
      setProtocolsData(newProtocolsData);
      setCurrentPage(newProtocolsData.current_page);
      setNextPage(newProtocolsData.next_page);
      setPreviousPage(newProtocolsData.prev_page);
      setPerPage(newProtocolsData.per_page);
      setTotal(newProtocolsData.total_protocols);
    }
    else {
      return;
    }
  }

  const handleSearchContainer = (setIsPoppedOut, show, setShow, ref) => {
    if (show){
      setIsPoppedOut(true);
      setTimeout(() => {
        setShow(false);
        setIsPoppedOut(false);
      },280);
    }
    else {
      setShow(true);
      if (ref){
        setTimeout(() => {
          ref.current.focus();
        }, 280);
      }
    }
  }

  async function handleSearch(input) {
    if (input === false){
      setNomeSearch("");
    }
    const searchProtocolsData = await getProtocols(1, input === false ? "" : nomeSearch);
    setCurrentPage(searchProtocolsData.current_page);
    setNextPage(searchProtocolsData.next_page);
    setPreviousPage(searchProtocolsData.prev_page);
    setPerPage(searchProtocolsData.per_page);
    setTotal(searchProtocolsData.total_protocols);
    setProtocolsData(searchProtocolsData);
  }

  async function getAlertDelete(id) {
    if (id){
      await setAlert("");
      const res = await deleteProtocolFunction(id);
      setAlert(res[1]);
      assignData();
      return res;
    }
  }

  async function exportProtocols() {
    await setLoading(<Loading/>);
    await setAlert("");
    try {
      const res = await axios
      .get(`${Url}/protocols_pdf`, {
        headers: {
          Authorization: "Bearer "+getUser().token,
        },
        responseType: 'arraybuffer',
      });
      const blob = new Blob([res.data], { type: 'application/pdf' });
      const pdfUrl = URL.createObjectURL(blob);
      setLoading("");
      window.open(pdfUrl, "_blank");
    }
    catch (err) {
      if (err.request && err.request.status === 401){
        var newToken = await RefreshToken(err);
        if (newToken) {
          return await exportProtocols();
        } else {
          window.location.reload();
        }
      }
      else {
        setLoading("");
        console.error(err);
        return setAlert(<Alert type={"error"}>Ocorreu um erro ao exportar os protocolos</Alert>);
      }
    };
  }

  function getLastPage(){
    const calc = total / perPage;
    const calcNoDecimals = Math.trunc(calc);
    if (calc > calcNoDecimals) return calcNoDecimals + 1;
    else return calcNoDecimals;
  }

  return (
    <div className="body">
      {loading}
      {alert}
      {deleteProtocol}
      <NavBar current={"protocolos"} setDisappear={setLoadingData} userPermissions={userPermissions} />
      {
        loadingData ? ""
        :
        <div style={{position: "relative"}}>
          <div className={styles.tableButtons}>
            <button className={styles.btnAdd} onClick={() => navigate("/protocolos/adicionar")}>
              <HiPlus size={20}/>
              <p className={styles.textAdd}>Adicionar</p>
            </button>
            <button className={`${styles.btnSearch} ${showSearch ? styles.btnSearchActive : ""}`} onClick={() => handleSearchContainer(setIsPoppedOutSearch, showSearch, setShowSearch, searchRef)}>
              <HiSearch size={20}/>
              <p className={styles.textAdd}>Procurar</p>
            </button>
            <button className={styles.btnCategories} onClick={() => navigate("/protocolos-categorias")}>
              <HiSquares2X2 size={20}/>
              <p className={styles.textAdd}>Categorias</p>
            </button>
            {
              protocolsData?.protocols?.length > 0 ?
              <button className={styles.btnExport} onClick={() => exportProtocols()}>
                <HiDownload size={20}/>
                <p className={styles.textAdd}>Exportar</p>
              </button>
              :""
            }
          </div>
          <div className={styles.content}>
            {
              showSearch ?
                <div className={`${styles.container} ${showSearch ? styles.popin : ""} ${isPoppedOutSearch ? styles.popout : ""}`}  >
                  <input 
                    className={styles.searchInput}
                    ref={searchRef}
                    onChange={(e) => setNomeSearch(e.target.value)}
                    placeholder="Procurar por nome"
                    value={nomeSearch}
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        handleSearch();
                      }
                    }}
                  />
                  <div style={{backgroundColor: "var(--inputBackground)", display: "flex", borderTopRightRadius: "4px", borderBottomRightRadius: "4px"}}>
                    <button className={styles.btn} style={{cursor: "default", marginRight: "0"}} onClick={() => handleSearch(false)}><HiX size={16} color="#9c9c9c"/></button>
                    <button className={styles.btn} style={{marginLeft: "0"}} onClick={() => handleSearch()}><HiSearch size={18}/></button>
                  </div>
                </div>
              : ""
            }
            <div className={styles.table3buttons}>
              <div className={styles.protocolsColumn}>
                <p>Nome</p>
                <p>Descrição</p>
                <p>Categoria</p>
                <p>Empresas</p>
                <p>Link</p>
                <p>Ações</p>
              </div>
              <div className={styles.scrollContent}>
                {
                  protocolsData?.protocols?.length > 0 ?
                    protocolsData?.protocols?.map((protocol, index) =>
                      <div key={protocol.id} className={styles.protocolsInfo} style={ index % 2 !== 0 ? {backgroundColor: "var(--inputBackground)"} : {}}>
                        <p title={protocol.name ? protocol.name : ""}>{protocol.name ? protocol.name : "-"}</p>
                        <p title={protocol.description ? protocol.description : ""}>{protocol.description ? protocol.description : "-"}</p>
                        <p title={protocol.type?.name ? protocol.type?.name : ""}>{protocol.type?.name ? protocol.type?.name : "-"}</p>
                        <p title={protocol.companies ? protocol.companies : ""}>{protocol.companies ? protocol.companies : "-"}</p>
                        <p title={protocol.link ? protocol.link : ""}>{protocol.link ? `${protocol.link}` : "-"}</p>
                        <div className={styles.actions}>
                          <HiPencil onClick={() => navigate("/protocolos/"+protocol.id, {state: {page: currentPage}})} className={styles.icon} size={22}/>
                          <HiTrash className={styles.icon} onClick={() => setDeleteProtocol(<DeleteModal close={setDeleteProtocol} objectId={protocol.id} objectName={`o protocolo ${protocol.name}`} deleteFunction={getAlertDelete}/>)} size={22}/>
                        </div>
                      </div>
                    )
                  : 
                  <div className={styles.noData}>
                    <p>Não existem dados</p>
                  </div>
                }
              </div>
              {
                previousPage || nextPage ?
                  <div className={styles.arrows}>
                    <TbArrowBigLeftLinesFilled size={28} color={currentPage && currentPage > 1 ? "" : "#00000000"} onClick={() => handlePageChange(true, 1)}/>
                    <TbArrowBigLeftFilled size={28} color={previousPage ? "" : "#00000000"} onClick={() => handlePageChange(false)}/>
                    {currentPage ? currentPage : ""}
                    <TbArrowBigRightFilled size={28} color={nextPage ? "" : "#00000000"} onClick={() => handlePageChange(true)}/>
                    <TbArrowBigRightLinesFilled size={28} color={currentPage !== getLastPage() ? "" : "#00000000"} onClick={() => handlePageChange(true, getLastPage())}/>
                  </div>
                : ""
              }
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default Protocolos;